import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import authService from '../services/authService';
import BackLink from '../components/auth/BackLink';
import FormField from '../components/common/FormField';
import Alert from '../components/common/Alert';
import { validateEmail } from '../utils/validators';
import './ApplicantPages.css';

// Ask for a link to choose a new password. It also lets someone who applied through an emailed link set a first password.
const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const problem = validateEmail(email);
    if (problem) {
      setError(problem);
      return;
    }
    setError('');
    setBusy(true);
    try {
      await authService.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.response?.status === 429 ? 'Too many attempts. Please wait a minute and try again.' : 'Something went wrong. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ap-center">
      <BackLink />
      <div className="ap-card ap-card--narrow">
        <h1 className="ap-brand"><Link to="/">TenantVerify SA</Link></h1>
        {sent ? (
          <>
            <h2>Check your email</h2>
            <p>If that address has an account, we have sent a link to choose a new password. It works for an hour.</p>
            <Link to="/login" className="ap-button ap-button--ghost">Back to log in</Link>
          </>
        ) : (
          <>
            <h2>Choose a new password</h2>
            <p className="ap-muted">
              Enter your email address and we will send you a link. If you applied for a property through an emailed link,
              this is also how you set your first password.
            </p>
            <form onSubmit={submit} noValidate>
              {error && <Alert type="error" message={error} />}
              <FormField label="Email address" name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
              <button type="submit" className="btn-primary ap-button" disabled={busy}>{busy ? 'Sending...' : 'Send me a link'}</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
